import { useTranslation } from 'react-i18next';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import InputLabel from '@mui/material/InputLabel';

export default function LanguageSelector({ language, setLanguage, isDrawer = false }) {
  const { t } = useTranslation();

  return (
    <FormControl variant="standard" sx={{ ml: isDrawer ? 0 : 2, minWidth: 50, color: 'white' }}>
      {isDrawer && <InputLabel id="play-label">{t('Properties language')}</InputLabel>}
      <Select
        disableUnderline
        value={language}
        onChange={(event) => setLanguage(event.target.value)}
        sx={{
          color: 'white',
          '& .MuiSvgIcon-root': { color: 'white' },
        }}
      >
        <MenuItem value="ro">{isDrawer ? t('RO') : t('roShort')}</MenuItem>
        <MenuItem value="en">{isDrawer ? t('EN') : t('enShort')}</MenuItem>
        <MenuItem value="de">{isDrawer ? t('DE') : t('deShort')}</MenuItem>
        <MenuItem value="hu">{isDrawer ? t('HU') : t('huShort')}</MenuItem>
      </Select>
    </FormControl>
  );
}
